import { render, staticRenderFns } from "./edit-commission.vue?vue&type=template&id=59d73a13&scoped=true"
import script from "./edit-commission.vue?vue&type=script&lang=js"
export * from "./edit-commission.vue?vue&type=script&lang=js"
import style0 from "./edit-commission.vue?vue&type=style&index=0&id=59d73a13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d73a13",
  null
  
)

export default component.exports